import React from "react";
import { Button } from "react-bootstrap";
import cx from "classnames";
import PropTypes from "prop-types";

const KnoaButton = ({
                        variant = "default",
                        size,
                        block,
                        round,
                        icon,
                        pullRight,
                        className,
                        children,
                        ...rest
                      }) => {
  const btnClasses = cx(className, {
    "btn-block": block,
    "rounded-pill": round,
    "btn-icon": icon,
    "float-end": pullRight,
  });

  return (
      <Button type="button" variant={variant} size={size} className={btnClasses} {...rest}>
        {children}
      </Button>
  );
};

KnoaButton.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.oneOf(["sm", "lg"]),
  block: PropTypes.bool,
  round: PropTypes.bool,
  icon: PropTypes.bool,
  pullRight: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default KnoaButton;